import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/WeekHeader.css';

interface WeekHeaderProps {
  dates: Date[];
}

const WeekHeader: React.FC<WeekHeaderProps> = ({ dates }) => {
  const today = format(new Date(), 'yyyy-MM-dd');
  const { language } = useTranslation();
  
  const getDayOfWeek = (date: Date) => {
    const daysJa = ['日', '月', '火', '水', '木', '金', '土'];
    const daysEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const days = language === 'ja' ? daysJa : daysEn;
    return days[date.getDay()];
  };
  
  return (
    <div className="week-header">
      {dates.map((date, index) => {
        const dateStr = format(date, 'yyyy-MM-dd');
        const isToday = dateStr === today;
        
        return (
          <div 
            key={index} 
            className={`week-header-day ${isToday ? 'today' : ''}`}
          >
            <div className="day-label">{getDayOfWeek(date)}</div>
            <div className="day-date">{format(date, 'd')}</div>
          </div>
        );
      })}
    </div>
  );
};

export default WeekHeader;